import { authFetch, parseAuthJson } from "@/lib/authClient";

type NewsletterResponse = {
	message?: string;
	error?: string;
	user?: { newsletterSubscribed?: boolean };
};

/** Iscrive l'utente autenticato alla newsletter. */
export async function subscribeNewsletter(): Promise<{
	ok: boolean;
	subscribed: boolean;
	error?: string;
}> {
	const res = await authFetch("/auth/newsletter", { method: "POST" });
	const body = await parseAuthJson<NewsletterResponse>(res);
	if (!res.ok) {
		return {
			ok: false,
			subscribed: false,
			error: body?.error || "Iscrizione non riuscita",
		};
	}
	return {
		ok: true,
		subscribed: Boolean(body?.user?.newsletterSubscribed ?? true),
	};
}

/** Disiscrive l'utente autenticato dalla newsletter. */
export async function unsubscribeNewsletter(): Promise<{
	ok: boolean;
	subscribed: boolean;
	error?: string;
}> {
	const res = await authFetch("/auth/newsletter", { method: "DELETE" });
	const body = await parseAuthJson<NewsletterResponse>(res);
	if (!res.ok) {
		return {
			ok: false,
			subscribed: true,
			error: body?.error || "Disiscrizione non riuscita",
		};
	}
	return {
		ok: true,
		subscribed: Boolean(body?.user?.newsletterSubscribed ?? false),
	};
}
